import * as React from 'react';

export function SvgSlack(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M6.7818 14.3745C6.7818 15.4152 5.9316 16.2654 4.8908 16.2654C3.8503 16.2654 3 15.4152 3 14.3745C3 13.3338 3.8502 12.4836 4.8909 12.4836H6.7818V14.3745ZM7.7346 14.3745C7.7346 13.3338 8.5848 12.4836 9.6255 12.4836C10.6662 12.4836 11.5164 13.3338 11.5164 14.3745V19.109C11.5164 20.1498 10.6662 20.9999 9.6255 20.9999C8.5848 20.9999 7.7346 20.1498 7.7346 19.109V14.3745Z"
        fill="#E01E5A"
      />
      <path
        d="M9.6255 6.7818C8.5848 6.7818 7.7346 5.9316 7.7346 4.8908C7.7346 3.8503 8.5848 3 9.6255 3C10.6662 3 11.5164 3.8502 11.5164 4.8909V6.7818H9.6255ZM9.6254 7.7346C10.6661 7.7346 11.5163 8.5848 11.5163 9.6255C11.5163 10.6662 10.6661 11.5164 9.6254 11.5164H4.891C3.8502 11.5164 3 10.6662 3 9.6255C3 8.5848 3.8502 7.7346 4.8909 7.7346H9.6254Z"
        fill="#36C5F0"
      />
      <path
        d="M17.2183 9.6255C17.2183 8.5848 18.0684 7.7346 19.1091 7.7346C20.1499 7.7346 21 8.5848 21 9.6255C21 10.6662 20.1499 11.5164 19.1091 11.5164H17.2183V9.6255ZM16.2654 9.6254C16.2654 10.6661 15.4152 11.5163 14.3745 11.5163C13.3338 11.5163 12.4836 10.6661 12.4836 9.6254V4.891C12.4836 3.8502 13.3338 3 14.3745 3C15.4152 3 16.2654 3.8502 16.2654 4.8909V9.6254Z"
        fill="#2EB67D"
      />
      <path
        d="M14.3745 17.2183C15.4152 17.2183 16.2654 18.0684 16.2654 19.1091C16.2654 20.1499 15.4152 21 14.3745 21C13.3338 21 12.4836 20.1499 12.4836 19.1091V17.2183H14.3745ZM14.3745 16.2654C13.3338 16.2654 12.4836 15.4152 12.4836 14.3745C12.4836 13.3338 13.3338 12.4836 14.3745 12.4836H19.109C20.1498 12.4836 20.9999 13.3338 20.9999 14.3745C20.9999 15.4152 20.1498 16.2654 19.109 16.2654H14.3745Z"
        fill="#ECB22E"
      />
    </svg>
  );
}
